
export default {
	init() {

		/* HERO */
		const hexFront = document.querySelector(".secondary-hero .hex-group .front");
		const hexBack = document.querySelector(".secondary-hero .hex-group .back");
		const heroTitle1 = document.querySelector(".secondary-hero h1 .title-0");
		const heroTitle2 = document.querySelector(".secondary-hero h1 .title-1");
		const heroTitle3 = document.querySelector(".secondary-hero h1 .title-2");

		if (hexFront) {
			setTimeout(function(){
				heroTitle1.classList.add("off");
				heroTitle2.classList.add("on");
				if (window.innerWidth > 1023) {
					hexFront.classList.add("run-1");
					hexBack.classList.add("run-1");
				}
			}, 1500);

			setTimeout(function(){
				heroTitle2.classList.remove("on");
				heroTitle2.classList.add("off");
				heroTitle3.classList.add("on");
				if (window.innerWidth > 1023) {
					hexFront.classList.add("run-2");
					hexBack.classList.add("run-2");
				}
			}, 3000);
		}

		/* ACCORDION SECTION */
		const accordion_items = document.getElementsByClassName('accordion-item');
		if (accordion_items !== null) {
			for (let acc_index = 0; acc_index < accordion_items.length; acc_index++) {
				const accordion_item = accordion_items[acc_index];
				accordion_item.querySelector('.top button').addEventListener('click', function () {
					const accordion_button = this;
					accordion_item.classList.toggle('open');
					if (accordion_item.classList.contains('open')) {
						accordion_button.setAttribute('aria-expanded', true);
						accordion_item.querySelector('.bottom').setAttribute('aria-hidden', false);
					} else {
						accordion_button.setAttribute('aria-expanded', false);
						accordion_item.querySelector('.bottom').setAttribute('aria-hidden', true);
					}
				})
			}
		}

		/* MOVING HEX */
		const hexContainerOffsetTop = document.querySelector(".why-choose").offsetTop;
		const hex = document.querySelector(".why-choose .hex");
		const groups = document.querySelectorAll(".why-choose .group");
		const group1Top = document.querySelector(".why-choose .group-1 .hex-title").offsetTop;

		if (group1Top) {
			hex.style.top = group1Top+"px";
			hex.classList.add("left");
			hex.firstElementChild.style.opacity = "1";

			const moveHex = () => {

				if (window.innerWidth > 1023) {

					const winHeight = window.innerHeight;
					let scroll_top = (window.scrollY - hexContainerOffsetTop) + 630;

					groups.forEach(group => {

						let group_top =  group.offsetTop + 100;

						if (scroll_top >= group_top) {

							hex.style.top = group_top+"px";
							const thisGroup = group.dataset.group;
							const hexImages = hex.children;

							for (let i = 0; i < hexImages.length; i++) {
								hexImages[i].style.opacity = "0";
							}

							hexImages[thisGroup].style.opacity = "1";

							if (group.lastElementChild.classList.contains("hex-title")) {
								hex.classList.remove("left");
								hex.classList.add("right");
							} else {
								hex.classList.remove("right");
								hex.classList.add("left");
							}
						}

					});

				}

			}

			window.addEventListener("scroll", moveHex);

			const moveSections = () => {

				const groups = document.querySelectorAll(".page-template-template-secondary .why-choose .group");

				groups.forEach(group => {
					const firstSection = group.firstElementChild;

					if (window.innerWidth < 1024) {
						if (firstSection.classList.contains("hex-content")) {
							if (!group.classList.contains("moved")) {
								group.classList.add("moved");
								const movedSection = firstSection;
								firstSection.remove();
								group.insertAdjacentElement("beforeend", movedSection);
							}
						}
					} else {
						if (group.classList.contains("moved")) {
							group.classList.remove("moved");
							const movedSection = firstSection;
							firstSection.remove();
							group.insertAdjacentElement("beforeend", movedSection);
						}
					}
				});

			}

			moveSections();

			window.addEventListener("resize", moveSections);

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
